import { render, staticRenderFns } from "./GroupsListTable.vue?vue&type=template&id=77b4fa96"
import script from "./GroupsListTable.vue?vue&type=script&lang=ts"
export * from "./GroupsListTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports